'use strict';
const trackingUtils = require('../modules/utils/tracking.utils');
const HIDDEN_CLASS = 'odf-hidden';
const NEXT_PAGE = 1;
const PREV_PAGE = -1;

Odigeo.defineWidget('results_load_more', Odigeo.Widget.extend({
    viewClass: Odigeo.View.extend({
        selectors: {
            paginationContainer: '.pagination',
            resultsMoreButton: '.results_more_button',
            loader: '.results_moreresults',
            resultsMoreButtonContainer: '.results_more_button_container',
            nextButton: '.next_button',
            noMoreResults: '.no_more_results',
        },
        render() {
            this.$el.html(this.templates.resultsLoadMoreTemplate({
                paginationType: this.widget.options.paginationType,
                keys: this.pluralizeKeys(this.keys),
            }));
            this.updateDomSelectorsToCache();
            this.enhancePagination();
            this.togglePaginationContainer(true);
        },
        enhancePagination() {
            Odigeo.UIElements.enhancePagination(this.$cachedSelectors.paginationContainer, {
                maxnumberOfResultPagesShown: parseInt(this.widget.options.paginationMaxPageSet, 10),
                nextCallback: Odigeo._.bind(this.nextPreviousHandler, this, NEXT_PAGE),
                previousCallback: Odigeo._.bind(this.nextPreviousHandler, this, PREV_PAGE),
                loadPageCallback: Odigeo._.bind(this.loadResultsFromPagination, this),
                loadTrackingCallback: Odigeo._.bind(this.loadTrackingPagination, this),
            });
            this.updateDomSelectorsToCache();
        },
        nextPreviousHandler(direction) {
            this.model.doResultsLoad(direction);
            this.widget.model.set('trackingLabel',
                (direction === NEXT_PAGE ? 'page_selected_next_' : 'page_selected_previous_') +
                this.widget.model.get('pagesLoaded'));
            Odigeo.trigger(this.widget.id + ':loadResults', direction, true);
        },
        loadResultsFromPagination(page, isDelta) {
            this.widget.model.set('trackingLabel', 'page_selected_' + page);
            Odigeo.trigger(this.widget.id + ':loadResults', page, isDelta);
            Odigeo.SessionScope.gpt.page = page;
        },
        loadTrackingPagination() {
            trackingUtils.trackEventWithCategory('flights_results', 'results_list', this.widget.model.get('trackingLabel'));
        },
        repaintPagination(paginationData) {
            this.$cachedSelectors.paginationContainer.trigger('repaintPagination', paginationData);
        },
        clearResultsPagination() {
            this.togglePaginationContainer(this.hasToHideMoreResultsButton());
            this.toggleLoader(true);
        },
        toggleNoMoreResults(toggle) {
            this.toggleLoader(true);
            this.$cachedSelectors.noMoreResults.toggleClass(HIDDEN_CLASS, toggle);
            this.$cachedSelectors.resultsMoreButtonContainer.toggleClass(HIDDEN_CLASS, this.hasToHideMoreResultsButton() || !toggle);
        },
        togglePaginationContainer(toggle) {
            this.$cachedSelectors.paginationContainer.toggleClass(HIDDEN_CLASS, this.hasToHideMoreResultsButton() || toggle);
        },
        hasToHideMoreResultsButton() {
            const isMobileResults2Batches = Odigeo.AB.isMobileResults2Batches && !Odigeo.SessionScope.marketingPortalIsMeta;
            const isFirstBatch = false;
            return isMobileResults2Batches && isFirstBatch;
        },
        toggleLoader(toggle) {
            this.$cachedSelectors.loader.toggleClass(HIDDEN_CLASS, toggle);
        },
        pluralizeKeys(keys) {
            keys.showMoreResults = Odigeo.Utils.replaceCmsKeyArgs(keys.showMoreResults, this.widget.options.resultsPerPage);
            return keys;
        },
        listenRouteChanges() {
            Odigeo.once('routeChange', Odigeo._.bind(function(route) {
                this.listenRouteChanges();
            }, this));
        },
    }),
    modelClass: Odigeo.Model.extend({
        defaults: {
            pagesLoaded: 1,
        },
        doResultsLoad(direction) {
            this.set('pagesLoaded', this.get('pagesLoaded') + direction);
        },
        init() {},
        resetPagination() {
            this.set('pagesLoaded', 1);
        },
    }),
    init() {
        this.view.render();
    },
    clearResultsPagination() {
        this.model.resetPagination();
        this.view.clearResultsPagination();
    },
    toggleNoMoreResults(toggle) {
        this.view.toggleNoMoreResults(toggle);
    },
    togglePaginationContainer(toggle) {
        this.view.togglePaginationContainer(toggle);
    },
    repaintPagination(paginationData) {
        this.view.repaintPagination(paginationData);
    },
    toggleLoader(toggle) {
        this.view.toggleLoader(toggle);
    },
}));
